import { debounce } from "../../utils/debounce.js";

const BURGER_SELECTOR = "[data-burger]";
const BURGER_NAV_SELECTOR = "[data-burger-nav]";
const BURGER_ACTIVE_CLASS = "active";

const NO_SCROLL_CLASS = "no-scroll";


/**
 * Initialize burger menu
 * @returns
 */
export const initBurger = () => {
    // Найти элементы бургер-меню и навигации
    const burgerBtn = document.querySelector(BURGER_SELECTOR);
    const burgerNav = document.querySelector(BURGER_NAV_SELECTOR);

    // Проверить, существуют ли эти элементы
    if (!burgerBtn || !burgerNav) {
        console.warn("Burger button or navigation not found.");
        return;
    }

    let currentWidth = window.innerWidth;

    burgerBtn.addEventListener("click", () => {
        if (burgerBtn.classList.contains(BURGER_ACTIVE_CLASS)) {
            closeBurger(burgerBtn, burgerNav, BURGER_ACTIVE_CLASS);
        } else {
            openBurger(burgerBtn, burgerNav, BURGER_ACTIVE_CLASS);
        }
    });

    window.addEventListener(
        "resize",
        debounce(() => {
            if (currentWidth === window.innerWidth) return;
            currentWidth = window.innerWidth;
            closeBurger(burgerBtn, burgerNav, BURGER_ACTIVE_CLASS);
        }, 100)
    );
};

/**
 * Close burger menu
 */
const closeBurger = (btn, nav, className) => {
    btn.classList.remove(className);
    nav.classList.remove(className);
    document.body.classList.remove(NO_SCROLL_CLASS);
};

/**
 * Open burger menu
 */
const openBurger = (btn, nav, className) => {
    btn.classList.add(className);
    nav.classList.add(className);
    document.body.classList.add(NO_SCROLL_CLASS);
};
